import { isMobile, closeDrawer, openDrawer } from './js-helpers.js';

const cookies = document.querySelector('[data-drawer-type="cookies"]');
const newsletter = document.querySelector('[data-drawer-type="newsletter"]');

document.querySelectorAll('button[data-drawer]').forEach(btn => {
	const drawer = document.querySelector(`[data-drawer-type="${btn.dataset.drawer}"]`);
	if (!drawer) return;

	btn.addEventListener('click', async () => {
		await closeDrawer();

		if (!btn.classList.contains('active')) {
			openDrawer(drawer);
		}
	});
});

document.querySelectorAll('button.drawer-close').forEach(btn =>
	btn.addEventListener('click', () => {
		btn.classList.add('active');

		closeDrawer(btn.closest('.drawer-wrapper'));
	})
);

document.querySelectorAll('button.drawer-backdrop').forEach(btn =>
	btn.addEventListener('click', () => {
		closeDrawer(btn.closest('.drawer-wrapper'));
	})
);

if (!isMobile) {
	document.addEventListener('keyup', event => {
		if (event.key === 'Escape') closeDrawer(newsletter);
	});
}

if (cookies && localStorage.getItem('cookies')) {
	cookies.remove();
}

if (newsletter) {
	if (!cookies || cookies && localStorage.getItem('cookies')) {
		if (!localStorage.getItem('newsletter')) {
			const newsletter = document.querySelector('[data-drawer-type="newsletter"]')

			setTimeout(() => {
				openDrawer(newsletter);
			}, (Number(newsletter.dataset.timer) || 1) * 1000);
		}
	}
}
